(() => {
  if (customElements.get("tabs-main")) {
    return;
  }

  class TabsMain extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        tabs: "[data-tab]",
        buttons: "[data-button]",
      };
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll(this.selectors.tabs);
      this.button = this.querySelectorAll(this.selectors.buttons);

      [...this.button].forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
      this.updateDisclaimerList();
    }

    updateDisclaimerList() {
      const activeTab = [...this.tabs].filter((tab) =>
        tab.classList.contains("is-active")
      )[0];
      const tabId = activeTab.dataset.listId;
      const disclaimerList = document.querySelector(".js-disclaimer-list");
      if (!disclaimerList) return;
      const disclaimerListItems =
        disclaimerList.querySelectorAll(".js-list-item");

      const disclaimerSlider = disclaimerList.querySelector(".slick-slider");
      // Filter disclaimers in slider via Slick
      if (disclaimerSlider) {
        $(disclaimerSlider).slick('slickUnfilter');
        $(disclaimerSlider).slick('slickFilter', function() {
          // Include any slides without a data-id and any with data-id matching tab ID
          return !this.hasAttribute('data-id') || this.dataset.id == tabId;
        });

      // Filter non-slider disclaimers
      } else {
        disclaimerListItems.forEach((disclaimerListItem) => {
          disclaimerListItem.classList.toggle(
            "hidden",
            tabId !== disclaimerListItem.dataset.id
          );
        });
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      this.updateActiveTab(event.target);
    }

    updateActiveTab(button = null, newTabId = -1) {
      if (button === null && newTabId === -1) {
        return;
      }

      if (button === null) {
        button = this.querySelector(
          `${this.selectors.buttons}[data-tab-id="${newTabId}"]`
        );
      }

      const parent = button.parentNode;
      const tabId = button.getAttribute("data-tab-id");
      parent.parentElement
        .querySelector(".is-active")
        .classList.remove("is-active");
      parent.classList.add("is-active");

      [...this.tabs].forEach((tab) => {
        tab.classList.toggle("is-active", tab.dataset.id === tabId);
      });

      this.updateDisclaimerList();

      if (newTabId !== -1) return;
      this.updateTabSelect(tabId);
    }

    updateTabSelect(tabId) {
      const select = this.closest("[data-wrapper]").querySelector(
        `.js-tabs-select[id="${this.dataset.id}"]`
      );
      if (!select) return;
      select.value = tabId;
    }
  }

  customElements.define("tabs-main", TabsMain);

  const handleTabSelectChange = (event) => {
    const target = event.target;
    const wrapper = target.closest("[data-wrapper]");
    const tab = wrapper.querySelector(
      `tabs-main[data-id="${target.getAttribute("id")}"]`
    );
    if (!tab) return;
    tab.updateActiveTab(null, target.value);
  };

  [...document.querySelectorAll(".js-tabs-select")].forEach((tabSelect) => {
    tabSelect.addEventListener("change", handleTabSelectChange);
  });
})();
